<template>
  <div id="about" class="row profile">
    <div class="col author">
      <picture>
        <source srcset="@/assets/IMG_2385_1.webp" class="rounded-circle" type="image/webp" />
        <source srcset="@/assets/IMG_2385_1.jpg" class="rounded-circle" type="image/jpeg" />
        <img src="@/assets/IMG_2385_1.jpg" class="rounded-circle" />
      </picture>
      <h1>{{ title }}</h1>
    </div>
    <div class="col short-intro">
      <blockquote class="blockquote align-middle text-center">
        <p class="mb-0">{{ quote }}</p>
        <div class="blockquote-footer">{{ quoteAuthor }}</div>
      </blockquote>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    quote: String,
    quoteAuthor: String
  }
};
</script>

<style>
</style>
